export const linear = (a, b) => x =>
  ((a.y - b.y) / (a.x - b.x)) * x + (a.y - ((a.y - b.y) / (a.x - b.x)) * a.x);
